/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../../app/constants/designer_events';

xplenty.controller('packages.item.version.controller', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$window',
  'notify',
  'Package',
  'modalService',
  'Designer',
  'errorsViewerService',
  '$translate',
  'variables',
  'item',
  'confirmationDialog',
  'packageSharedService',

  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $window,
    notify,
    Package,
    modalService,
    Designer,
    errorsViewerService,
    $translate,
    variables,
    item,
    confirmationDialog,
    packageSharedService,
  ) {
    const $win = angular.element($window);

    $scope.loaded = false;
    $scope.designer = null;
    $scope.versionView = true;
    $scope.type = 'item';

    let resizeTimeout;

    const destroyMainScroll = function () {
      angular.element('.page-scroll-wrapper').perfectScrollbar('destroy');
    };

    const packageResize = function () {
      if (resizeTimeout) $timeout.cancel(resizeTimeout);
      resizeTimeout = $timeout(function () {
        $rootScope.$broadcast(DESIGNER_EVENTS.RESIZE, $rootScope.mainSize);
        destroyMainScroll();
        angular.element('.page-scroll-wrapper').scrollTop(0);
      }, 100);
    };

    $scope.$on(DESIGNER_EVENTS.CREATED, function (event, designer) {
      if ($stateParams.version) {
        $scope.versionView = true;

        Package.version($stateParams.id, $stateParams.version).subscribe(
          function (res) {
            $scope.package = res;

            if ($scope.designer) return $scope.designer.package;
            return null;
          },
          function () {
            notify.error(null, $translate.instant('response.422.message'));
          },
        );
      }

      packageSharedService.setDesigner(designer);
    });

    $rootScope.getPackage = function () {
      if ($scope.designer) return $scope.designer.package;
      return null;
    };

    // Router resolve gets the package for us
    $rootScope.title = item.name;
    $scope.package = item;
    $scope.loaded = true;
    $timeout(packageResize, 100);
    $timeout(destroyMainScroll, 1000);

    $win.on('resize', packageResize);

    $scope.$on('$stateChangeStart', function (argument) {
      $win.off('resize', packageResize);
    });

    $scope.$on(DESIGNER_EVENTS.COMPONENT_EDIT, function (event, component) {
      const $tempScope = $rootScope.$new();
      $tempScope.component = component;
      component.setEdit(true);
      $translate(['package.controller.modals.edit.actions.save', 'package.controller.modals.edit.actions.close']).then(
        function (t) {
          const modalSettings = {
            titleText: component.name,
            descriptionText: component.originalName,
            icon: component.icon,
            closeButtonText: t['package.controller.modals.edit.actions.close'],
            saveButtonText: t['package.controller.modals.edit.actions.save'],
            hasPadding: false,
            hasFooter: false,
            hasScroll: false,
            saveButtonHidden: true,
            autoInputFocus: false,
            onClose() {
              component.setEdit(false);
              $tempScope.$destroy();
              destroyMainScroll();
            },
          };

          modalService.showModal(modalSettings, '<component-editor ng-model="component"/>', $tempScope);
        },
      );
    });

    $scope.$on(DESIGNER_EVENTS.COMPONENT_MENU, function (event, hide) {
      if (!modalService.isVisible()) {
        const $tempScope = $rootScope.$new();

        $tempScope.hasSources = hide.sources;
        $tempScope.hasTransformations = hide.transformations;
        $tempScope.hasDestinations = hide.distanations;
        $tempScope.hasWorkflow = hide.workflow;
        $tempScope.sourceComponentId = hide.sourceComponentId;

        $translate([
          'package.controller.modals.component_menu.actions.save',
          'package.controller.modals.component_menu.actions.title',
          'package.controller.modals.component_menu.actions.description',
          'package.controller.modals.component_menu.actions.close',
        ]).then(function (t) {
          const modalSettings = {
            titleText: t['package.controller.modals.component_menu.actions.title'],
            descriptionText: t['package.controller.modals.component_menu.actions.description'],
            closeButtonText: t['package.controller.modals.component_menu.actions.close'],
            saveButtonText: t['package.controller.modals.component_menu.actions.save'],
            hasPadding: true,
            hasFooter: false,
            onSave() {
              modalService.hideModal();

              $tempScope.$destroy();
            },
            onClose() {
              $tempScope.$destroy();
            },
          };

          modalService.showModal(modalSettings, '<components-list />', $tempScope);
        });
      }
    });

    const removeModal = function () {
      $('.modal-backdrop').remove();
      $('.modal').remove();
    };

    let skipStateChangeStart;
    const redirectEventListener = $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
      // ui router bug calls the listener twice if state change was prevented
      if (skipStateChangeStart) {
        skipStateChangeStart = false;
        event.preventDefault();
        return;
      }

      if ($scope.designer && $scope.designer.package.dataChanged) {
        event.preventDefault();
        removeModal();
      } else {
        removeModal();
      }
    });
  },
]);
